import { useLocation } from 'react-router-dom';

export const useQueryParams = (search?: string) => {
  const location = useLocation();
  return new URLSearchParams(search ?? location.search);
};
